import { defineStore } from "pinia";

export const usePushNotificationStore = defineStore({
  id: "pushNotification",
  state: () => ({
    pendingDeepLink: null,
    foregroundNotification: null,
    permissionDenied: false,
  }),
  actions: {
    setPendingDeepLink(link) {
      this.pendingDeepLink = link;
    },
    clearPendingDeepLink() {
      this.pendingDeepLink = null;
    },
    setForegroundNotification(n) {
      this.foregroundNotification = n;
    },
    clearForegroundNotification() {
      this.foregroundNotification = null;
    },
    setPermissionDenied(v) {
      this.permissionDenied = Boolean(v);
    },
  },
});
